import cn from 'classnames'
import {FC, PropsWithChildren} from 'react'

import {Text, TextFontWeight, TextVariant} from '@/components/common/content/Text'
import {Link} from '@/i18n'
import {theme} from '@/theme/theme'
import {MOBILE_SCREENSIZE} from '@/utils/styles/breakpoints'

type PricingTableRowProps = {
  title?: string
  description?: string
  linkUrl?: string
  isDescriptionHiddenOnMobile?: boolean
  isMobileFullWidth?: boolean
}

export const PricingTableRow: FC<PropsWithChildren<PricingTableRowProps>> = ({
  title,
  description,
  linkUrl,
  isDescriptionHiddenOnMobile = false,
  isMobileFullWidth = false,
  children,
}) => (
  <>
    <li className="item">
      <div className={cn('row', isMobileFullWidth && 'full-width')}>
        <Text element="h4" fontWeight={TextFontWeight.bold}>
          {linkUrl ? (
            <Link href={linkUrl} legacyBehavior>
              <a className="service">{title}</a>
            </Link>
          ) : (
            title
          )}
        </Text>
        {children}
      </div>
      {description && (
        <div className={cn('description', isDescriptionHiddenOnMobile && 'hidden')}>
          <Text variant={TextVariant.text14} color={theme.palette.text.light}>
            {description}
          </Text>
        </div>
      )}
    </li>

    <style jsx>{`
      .item {
        padding: ${theme.spacing[3]} ${theme.spacing[6]};
      }
      .item:nth-child(even) {
        background-color: ${theme.palette.background.butterLight};
      }
      .row {
        display: flex;
        justify-content: space-between;
      }
      .service {
        color: inherit;
      }
      .service:hover {
        text-decoration: underline;
      }
      .description {
        margin-top: ${theme.spacing[1]};
      }
      @media ${MOBILE_SCREENSIZE} {
        .item {
          padding: ${theme.spacing[3]} ${theme.spacing[4]};
        }
        .item:last-child {
          border-bottom-left-radius: 16px;
          border-bottom-right-radius: 16px;
        }
        .row.full-width {
          display: block;
        }
        .hidden {
          display: none;
        }
      }
    `}</style>
  </>
)
